import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ServicePage.css';

function ServicePage() {
    const services = [
        {
            title: 'Payroll Management',
            description: 'Efficiently manage employee salaries, bonuses, deductions, and taxes with our comprehensive payroll solutions. Our system ensures timely and accurate payroll processing, compliance with local regulations, and seamless integration with accounting systems.',
            image: '/images/payroll.svg'
        },
        {
            title: 'Employee Database Management',
            description: 'Maintain a centralized and secure database of all employee information. This includes personal details, employment history, performance records, and more, easily accessible for HR teams.',
            image: '/images/payroll.svg'
        },
        {
            title: 'Recruitment and Onboarding',
            description: 'Simplify the recruitment process with our end-to-end solutions. From job postings and applicant tracking to interviews and onboarding, we make hiring efficient and effective.',
            image: '/images/payroll.svg'
        },
        {
            title: 'Training and Development',
            description: 'Offer tailored training programs to develop your employees’ skills and advance their careers. Our platform provides e-learning modules, performance tracking, and skill assessments.',
            image: '/images/payroll.svg'
        },
        {
            title: 'HR Analytics and Reporting',
            description: 'Gain insights into your workforce with advanced HR analytics and reporting tools. Make data-driven decisions to optimize HR strategies.',
            image: '/images/payroll.svg'
        },
        {
            title: 'Compliance Management',
            description: 'Ensure your company adheres to all relevant labor laws and regulations with our compliance management services. We keep you updated on legal requirements and help you maintain compliance.',
            image: '/images/payroll.svg'
        }
    ];

    return (
        <section className="services-page">
            <div className="container-fluid p-0">
                <header className="position-relative">
                    <img src="/images/aboutimg.svg" alt="About Us" className="img-fluid w-100 header-image" />
                    <div className="header-text position-absolute top-50 start-0 translate-middle-y p-4">
                        <h1 className="mt-4 text-white">Revolutionize Your HR <br /> Solutions with DM.</h1>
                        <p className="text-white">Streamline payroll, enhance employee management, and elevate your HR processes with our cutting-edge solutions.</p>
                        <a href="#our-services" className="btn btn-primary">Discover Our Services</a>
                    </div>
                </header>
                <div id="our-services" className="my-2">
                    <h2 className="text-center text-white">Our Services</h2>
                    <p className="text-center mb-5 text-white">We offer a comprehensive suite of HR solutions designed to streamline your operations, enhance employee satisfaction, and support your organizational growth. Our key services include:</p>
                    <div className="row">
                        {services.map((service, index) => (
                            <div className="col-md-6 col-lg-6 mb-4" key={index}>
                                <div className="card">
                                    <div className="card-body text-center d-flex flex-column">
                                        <img src={service.image} alt={service.title} className="service-icon mb-3" />
                                        <h5 className="card-title">{service.title}</h5>
                                        <p className="card-text flex-grow-1">{service.description}</p>
                                        <a href="/" className="demo btn btn-primary mt-auto">Book A Demo</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicePage;